<template>
  <div
    v-if="reminders.length"
    class="task-reminder-panel"
    :class="{ collapsed: collapsed }"
    :style="panelStyle"
  >
    <div class="trp-header" @mousedown.prevent="startDrag">
      <div class="trp-title">
        <span class="trp-badge">{{ reminders.length }}</span>
        <span v-if="!collapsed">Напоминания</span>
        <span v-else class="trp-collapsed-text">{{ firstTitle }}</span>
      </div>
      <div class="trp-actions" @mousedown.stop>
        <button type="button" class="trp-icon-btn" :title="collapsed ? 'Развернуть' : 'Свернуть'" @click="collapsed = !collapsed">
          {{ collapsed ? '▴' : '▾' }}
        </button>
      </div>
    </div>

    <div v-if="!collapsed" class="trp-list">
      <div v-for="task in reminders" :key="task.id" class="trp-item">
        <div class="trp-item-main" @click="openOrder(task)">
          <div class="trp-task-text">{{ task.taskText || 'Задача' }}</div>
          <div class="trp-meta">
            <span v-if="task.orderId">№ {{ task.orderId }}</span>
            <span v-if="task.dueDate" class="trp-due">{{ task.dueDate }}</span>
          </div>
        </div>
        <div class="trp-item-btns">
          <button type="button" class="trp-btn trp-btn-snooze" :disabled="busyId === task.id" @click="snooze(task)">
            Отложить 5 мин
          </button>
          <button type="button" class="trp-btn trp-btn-done" :disabled="busyId === task.id" @click="complete(task)">
            Выполнено
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskReminderPanel',
  props: {
    reminders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      collapsed: false,
      busyId: null,
      pos: { x: null, y: null },
      dragging: false,
      dragOffset: { x: 0, y: 0 },
    };
  },
  computed: {
    firstTitle() {
      const t = this.reminders[0];
      if (!t) return 'Напоминание';
      const text = t.taskText || 'Задача';
      return text.length > 28 ? text.slice(0, 28) + '…' : text;
    },
    panelStyle() {
      if (this.pos.x == null || this.pos.y == null) {
        return { right: '16px', bottom: '16px', left: 'auto', top: 'auto' };
      }
      return {
        left: `${this.pos.x}px`,
        top: `${this.pos.y}px`,
        right: 'auto',
        bottom: 'auto',
      };
    },
  },
  mounted() {
    window.addEventListener('mousemove', this.onDrag);
    window.addEventListener('mouseup', this.stopDrag);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.stopDrag);
  },
  methods: {
    startDrag(e) {
      if (e.button !== 0) return;
      const el = this.$el;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (this.pos.x == null) {
        this.pos = { x: rect.left, y: rect.top };
      }
      this.dragging = true;
      this.dragOffset = {
        x: e.clientX - this.pos.x,
        y: e.clientY - this.pos.y,
      };
    },
    onDrag(e) {
      if (!this.dragging) return;
      const w = this.$el ? this.$el.offsetWidth : 320;
      const h = this.$el ? this.$el.offsetHeight : 120;
      let x = e.clientX - this.dragOffset.x;
      let y = e.clientY - this.dragOffset.y;
      x = Math.max(8, Math.min(window.innerWidth - w - 8, x));
      y = Math.max(8, Math.min(window.innerHeight - h - 8, y));
      this.pos = { x, y };
    },
    stopDrag() {
      this.dragging = false;
    },
    openOrder(task) {
      this.$emit('open-order', task);
    },
    complete(task) {
      if (this.busyId) return;
      this.busyId = task.id;
      this.$emit('complete', task);
      // busy сбрасывается родителем через удаление item; подстраховка:
      setTimeout(() => {
        if (this.busyId === task.id) this.busyId = null;
      }, 4000);
    },
    snooze(task) {
      if (this.busyId) return;
      this.busyId = task.id;
      this.$emit('snooze', task);
      setTimeout(() => {
        if (this.busyId === task.id) this.busyId = null;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.task-reminder-panel {
  position: fixed;
  z-index: 10050;
  width: 320px;
  max-width: calc(100vw - 24px);
  background: #fff;
  border: 1px solid #e2e5ea;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  font-size: 13px;
  color: #1f2937;
  user-select: none;
}

.task-reminder-panel.collapsed {
  width: 260px;
}

.trp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: linear-gradient(180deg, #dc3545, #b91c1c);
  color: #fff;
  cursor: grab;
}

.trp-header:active {
  cursor: grabbing;
}

.trp-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  min-width: 0;
}

.trp-collapsed-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}

.trp-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 12px;
}

.trp-icon-btn {
  border: 0;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  line-height: 1;
}

.trp-icon-btn:hover {
  background: rgba(255, 255, 255, 0.28);
}

.trp-list {
  max-height: min(42vh, 360px);
  overflow-y: auto;
  background: #fff;
}

.trp-item {
  padding: 10px 12px;
  border-bottom: 1px solid #eef0f3;
}

.trp-item:last-child {
  border-bottom: 0;
}

.trp-item-main {
  cursor: pointer;
  margin-bottom: 8px;
}

.trp-item-main:hover .trp-task-text {
  color: #b91c1c;
}

.trp-task-text {
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 4px;
  word-break: break-word;
}

.trp-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
}

.trp-item-btns {
  display: flex;
  gap: 8px;
}

.trp-btn {
  flex: 1;
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.trp-btn:disabled {
  opacity: 0.55;
  cursor: wait;
}

.trp-btn-snooze {
  color: #374151;
  background: #f3f4f6;
}

.trp-btn-snooze:hover:not(:disabled) {
  background: #e5e7eb;
}

.trp-btn-done {
  color: #fff;
  background: #16a34a;
  border-color: #16a34a;
}

.trp-btn-done:hover:not(:disabled) {
  background: #15803d;
}
</style>
